export default __webpack_public_path__ + "dd46db5fca3c5f35efd878109541a0e1.png";